const $: JQueryStatic = global.$;

// Change Jquery deferred Error Hook so we can get links to the original source files, and not the webpack-internal
// NOTE: This method is overridden/redefined in ErrorControl as we need to handle errors that happen within dfds.
//       This method is "live" for a very brief period while the api is loading but once ErrorControl is defined it takes over.
$.Deferred.exceptionHook = function(e, _t) {
    const W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    console && console.error && W.test(e?.name) && console.error("Exception.Inside.Jquery.Deferred....", e, _t);
    //throw e; // need to throw the error or else we prevent other global err listeners from receiving it
    // actually, we can't throw the error as then the fail handlers don't work
}

const SOLVED_DFD = $.Deferred().resolve().promise();
const REJECTED_DFD = $.Deferred().reject().promise();

export default class DeferredUtil {
    /**
     * Equivalent of the Promise.all() method
     * @param deferredArray list of deferred to wait for
     * @returns {Promise.<[]>} Return a promise which will resolved in an array of result
     */
    all(deferredArray: JQueryDeferred<any>[]): JQueryPromise<any[]> {
        return $.when.apply($, deferredArray).then(function () {
            return Array.from(arguments);
        });
    }

    /**
     * Equivalent of the Promise.resolve() method
     *
     * Will try to cache the deferred
     * @returns {Promise.<>} Return an already resolved deferred
     */
    resolved(): JQueryPromise<any> {
        if (arguments.length === 0) {
            return SOLVED_DFD;
        }

        const dfd = $.Deferred();
        dfd.resolve.apply(dfd, arguments);

        return dfd.promise();
    }

    /**
     * Equivalent of the Promise.reject() method
     *
     * Will try to cache the deferred
     * @returns {Promise.<>} Return an already rejected deferred
     */
    rejected(): JQueryPromise<any> {
        if (arguments.length === 0) {
            return REJECTED_DFD;
        }

        const dfd = $.Deferred();
        dfd.reject.apply(dfd, arguments);

        return dfd.promise();
    }
}
